module.exports = __webpack_public_path__ + "img/ang7.85bd56c1.png";